<template>
  <v-container grid-list-xl fluid>
    <v-card flat class="homepagewidth" >
      <v-card-text>
        <v-layout justify-start align-start wrap>
          <v-flex xs12 xl6>
            <v-flex class="py-0">
                <motd />
            </v-flex>
            <v-flex class="py-4">
                <top10 type="global"></top10>
            </v-flex>
            <v-flex class="py-4">
                <devnotes />
            </v-flex>
          </v-flex>
          <v-flex xs12 xl3>
            <v-layout wrap align-center>
              <v-flex xs12>
                <userinfo></userinfo>
              </v-flex>
              <v-flex xs12>
                <dbstats></dbstats>
              </v-flex>
              <v-flex xs12>
                <asncountrycombo></asncountrycombo>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 xl3>
            <v-layout wrap align-center>
              <v-flex xs12>
                <gettingstarted />
              </v-flex>
              <v-flex xs12>
                <furtherinfo></furtherinfo>
              </v-flex>
              
              <v-flex xs12> 
                <!-- <info>
                  <template slot>
                      Homepage Info
                  </template>
                  <template slot="body">
                        The Home page is the first page users can visit following a successful login. 
                        Here users can visualise a summary of their personal information and AS information which is associated with their organisation.
                        The information for each ASN is provided by RIPE. Information regarding which users are associated with which AS is initially configured when a CSP is on-boarded however,
                        this can be altered in the user interface.
                  </template>
                </info> -->
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>

import top10 from '../../shared/operational/top-10.vue'
import motd from '../../shared/operational/m-o-t-d.vue'
import userinfo from '../../shared/operational/user-info.vue'
import dbstats from '../../shared/operational/event-to-episode-stats.vue'
import furtherinfo from '../../shared/operational/further-info.vue'
import gettingstarted from '../../shared/operational/getting-started.vue'
import asncountrycombo from '../../shared/operational/asn-country-search-combined.vue'
import info from '../../shared/operational/infopopout.vue'
import { findParentComponentByName } from '../utils/findParent.js'
import devnotes from '../../shared/operational/dev-notes.vue'


export default {
  name: 'HomePage',
  components: {
    motd,
    top10,
    dbstats,
    furtherinfo,
    userinfo,
    asncountrycombo,
    info,
    gettingstarted,
    devnotes
  },
  beforeMount() {
    let app = findParentComponentByName(this, 'app')
    app.checkSignedIn()
  },
  }

</script>